import './App.css';
import React from 'react';
import ARViewer from './components/ARViewer';

function App() {
  return (
    <div className="App">
      <ARViewer />
    </div>
  );
}

export default App;
